import { render, staticRenderFns } from "./ScheduleDispatch.vue?vue&type=template&id=0df80ba8&scoped=true"
import script from "./ScheduleDispatch.vue?vue&type=script&lang=js"
export * from "./ScheduleDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df80ba8",
  null
  
)

export default component.exports